module.exports = __webpack_public_path__ + "static/media/garima-correct.2459bd6e.mov";


//////////////////
// WEBPACK FOOTER
// ./src/projects/rostery/src/garima-correct.mov
// module id = 625
// module chunks = 0